import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import validation from "./validation"
import Layout from "../../components/layouts/layout"
import { useTrackFormStepArrival } from "../../utils/analytics"
import ContinueButton from "components/elements/styledButton/ContinueButton"
import ProgressBar from "utils/stepper"
import MorningApptBanner from "utils/morningApptBanner"

const Caregiverinfo = ({ nextStep, pationuser, prevStep, setUser, user }) => {
  const inputRef = useRef()
  const [nextBtn, setNextbtn] = useState(false)
  const [errField, setErrField] = useState({
    address1Err: "",
    address2Err: "",
    cityErr: "",
    countryErr: "",
    emailAddressErr: "",
    lastNameErr: "",
    nameErr: "",
    phoneNumberErr: "",
    stateErr: "",
    zipCodeErr: "",
  })

  useTrackFormStepArrival("caregiver_info")

  const validForm = async () => {
    const formValidity = await validation.validateWelcomeVisitOnSubmit(
      setErrField,
      user,
      inputRef,
      setUser
    )
    return formValidity
  }

  const handleChange = e => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    })
    validation.validateWelcomeVisitOnChange(e, setErrField, setUser, user)
  }
  const handleSubmit = async () => {
    const formIsValid = await validForm()
    if (formIsValid) {
      nextStep()
    }
  }
  const mailAddress = () => {
    if (user.check) {
      setUser({
        ...user,
        address1: "",
        address2: "",
        city: "",
        check: !user.check,
        country: "",
        state: "",
        user,
        zipCode: "",
      })
    } else {
      setUser({
        ...user,
        address1: pationuser.address1,
        address2: pationuser.address2,
        city: pationuser.city,
        country: pationuser.country,
        state: pationuser.state,
        zipCode: pationuser.zipCode,
        check: !user.check,
      })
    }
  }
  useEffect(() => {
    const nextCheck = () => {
      if (
        !user.name ||
        !user.lastName ||
        !user.city ||
        !user.country ||
        !user.state ||
        !user.zipCode ||
        !user.address1 ||
        !user.emailAddress ||
        !user.phoneNumber ||
        !user.careinformation
      ) {
        setNextbtn(false)
      } else {
        if (user.zipCode.length >= 5 && user.phoneNumber.length >= 12) {
          setNextbtn(true)
        } else {
          setNextbtn(false)
        }
      }
    }
    nextCheck()
  }, [user])

  const myStyle = {
    backgroundImage: "url(../images/caret-down.svg)",
  }
  return (
    <>
      <Layout>
        <section className="progress-bar-section">
          <div className="progress-bar-wrapper">
            <ProgressBar activeStep={1} />
          </div>
        </section>
        <MorningApptBanner />
        <section className="patient-information-section">
          <div className="container">
            <div className="patient-heading">
              <h4>Tell us more about you, the Caregiver.</h4>
            </div>
            <form className="patient-formSection" onSubmit={handleSubmit}>
              <div className="caregiver-form-details">
                <div className="radio-popup-section">
                  <div className="radio-buttons-form">
                    <div className="patient-form-wrapper checkinSection">
                      <div className="row">
                        <div className="col-md-9">
                          <h4>Are you the patient&apos;s primary Caregiver?</h4>
                        </div>
                        <div className="col-md-3 text-right">
                          <div className="d-flex" onChange={handleChange}>
                            <div className="form-check ctm-check">
                              <input
                                className="form-check-input"
                                defaultChecked={
                                  user.primary_caregiver === "true"
                                }
                                id="defaultCheck1"
                                name="primary_caregiver"
                                type="radio"
                                value="true"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="defaultCheck1"
                              >
                                Yes&nbsp;
                              </label>
                            </div>
                            <div className="form-check ctm-check">
                              <input
                                className="form-check-input"
                                defaultChecked={
                                  user.primary_caregiver === "false"
                                }
                                id="defaultCheck2"
                                name="primary_caregiver"
                                type="radio"
                                value="false"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="defaultCheck2"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="patient-form-wrapper checkinSection">
                      <div className="row align-items-center">
                        <div className="col-md-9">
                          <h4>Are you the legal guardian?</h4>
                        </div>
                        <div className="col-md-3 text-right">
                          <div className="d-flex" onChange={handleChange}>
                            <div className="form-check ctm-check">
                              <input
                                className="form-check-input"
                                defaultChecked="checked"
                                id="defaultCheck3"
                                name="legal_guardian"
                                type="radio"
                                value="true"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="defaultCheck3"
                              >
                                Yes&nbsp;
                              </label>
                            </div>
                            <div className="form-check ctm-check">
                              <input
                                className="form-check-input"
                                defaultChecked={user.legal_guardian === "false"}
                                id="defaultCheck4"
                                name="legal_guardian"
                                type="radio"
                                value="false"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="defaultCheck4"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="patient-form-wrapper checkinSection">
                      <div className="row">
                        <div className="col-md-9">
                          <h4>Are you the emergency contact?</h4>
                        </div>
                        <div className="col-md-3 text-right">
                          <div className="d-flex" onChange={handleChange}>
                            <div className="form-check ctm-check">
                              <input
                                className="form-check-input"
                                defaultChecked="checked"
                                id="defaultCheck1"
                                name="emergency_contact"
                                type="radio"
                                value="true"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="defaultCheck1"
                              >
                                Yes&nbsp;
                              </label>
                            </div>
                            <div className="form-check ctm-check">
                              <input
                                className="form-check-input"
                                defaultChecked={
                                  user.emergency_contact === "false"
                                }
                                id="defaultCheck2"
                                name="emergency_contact"
                                type="radio"
                                value="false"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="defaultCheck2"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="patient-form-wrapper">
                      <div className="pat-form-heading">
                        <h4>What is your relationship to the patient?</h4>
                      </div>
                      <div className="row align-items-center mt-4">
                        <div className="col-md-12 form-group">
                          <label className="label" htmlFor="selector_care_info">
                            Relationship to Patient<span>*Required</span>
                          </label>
                          <select
                            className="form-select form-control"
                            id="selector_care_info"
                            name="careinformation"
                            onChange={handleChange}
                            style={myStyle}
                            value={user.careinformation}
                          >
                            <option disabled selected value="">
                              Select Relationship
                            </option>
                            <option value="Aunt">Aunt</option>
                            <option value="Brother">Brother</option>
                            <option value="Cousin">Cousin</option>
                            <option value="Father">Father</option>
                            <option value="Friend">Friend</option>
                            <option value="Grandmother">Grandmother</option>
                            <option value="Grandfather">Grandfather</option>
                            <option value="Guardian">Guardian</option>
                            <option value="Husband">Husband</option>
                            <option value="Mother">Mother</option>
                            <option value="Step-Father">Step-Father</option>
                            <option value="Step-Mother">Step-Mother</option>
                            <option value="Sister">Sister</option>
                            <option value="Self">Self</option>
                            <option value="Uncle">Uncle</option>
                            <option value="Wife">Wife</option>
                          </select>
                        </div>
                        {!user.careinformation && (
                          <span className="input-error">
                            {errField.findAFacilityErr}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="caregiverPopup">
                    <div className="pat-form-para">
                      <p className="p_right">
                        Why do we ask for this information?
                      </p>
                      <div className="ctm-tooltip">
                        <div className="tooltip-header">
                          <h6>
                            {" "}
                            <span>
                              <i className="fa-solid fa-question"></i>
                            </span>
                            Why do we need this information?
                          </h6>
                        </div>
                        <div className="tooltip-content">
                          <p>
                            We use this information to ensure only the person
                            legally authorized to consent for the patient is
                            consulted in healthcare decisions. Typically this is
                            the patient&apos;s parent, but in some cases the
                            patient may have an appointed guardian.
                          </p>
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                </div>
                <div className="caregiver-details-container">
                  <div className="patient-form-wrapper">
                    <div className="pat-form-heading">
                      <h5>Caregiver Details </h5>
                    </div>
                    <div className="row">
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_first_name">
                          First Name<span>Required*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_first_name"
                          name="name"
                          onChange={handleChange}
                          placeholder="E.g - John"
                          type="text"
                          value={user.name}
                        />
                        {!user.name && errField.nameErr.length > 0 && (
                          <span style={{ color: "red" }}>
                            {errField.nameErr}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_last_name">
                          Last Name<span>Required*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_last_name"
                          name="lastName"
                          onChange={handleChange}
                          placeholder="E.g - Doe"
                          type="text"
                          value={user.lastName}
                        />

                        {!user.lastName && (
                          <span className="input-error">
                            {errField.lastNameErr}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_email">
                          Email Address<span>Required*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_email"
                          name="emailAddress"
                          onChange={handleChange}
                          placeholder="john.doe@gmail.com"
                          ref={inputRef}
                          type="text"
                          value={user.emailAddress}
                        />

                        {
                          <span className="input-error">
                            {errField.emailAddressErr}
                          </span>
                        }
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_phone">
                          Phone Number<span>Required*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_phone"
                          name="phoneNumber"
                          onChange={handleChange}
                          placeholder="E.g - 323-393-2222"
                          type="tel"
                          value={user.phoneNumber}
                        />
                        {errField.phoneNumberErr && (
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {errField.phoneNumberErr}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 patient-subheading">
                        <h5>Caregiver Address</h5>
                      </div>
                      <div className="col-md-12">
                        <div className="form-check checkbox-text">
                          <input
                            className="form-check-input"
                            defaultChecked={user.check}
                            id="flexCheckDefault"
                            onChange={mailAddress}
                            type="checkbox"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault"
                          >
                            Mailing Address the same as patient?
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_address1">
                          Address 1<span>Required*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_address1"
                          name="address1"
                          onChange={handleChange}
                          placeholder="1234 Street Name"
                          type="text"
                          value={user.address1}
                        />
                        {!user.address1 && (
                          <span style={{ color: "red" }}>
                            {" "}
                            {errField.address1Err}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_address2">
                          Address 2<span>Optional*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_address2"
                          name="address2"
                          onChange={handleChange}
                          placeholder="Apartment, Suite, P.O Box #"
                          type="text"
                          value={user.address2}
                        />
                        {!user.address2 && (
                          <span style={{ color: "red" }}>
                            {" "}
                            {errField.address2Err}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_city">
                          City<span>Required*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_city"
                          name="city"
                          onChange={handleChange}
                          placeholder="City"
                          type="text"
                          value={user.city}
                        />
                        {!user.city && (
                          <span style={{ color: "red" }}>
                            {" "}
                            {errField.cityErr}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="selector_state">
                          State<span>Required*</span>
                        </label>
                        <select
                          className="form-select form-control"
                          id="selector_state"
                          name="state"
                          onChange={handleChange}
                          style={myStyle}
                          value={user.state}
                        >
                          <option disabled value="">
                            Select State
                          </option>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AS">American Samoa</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="DC">District of Columbia</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="Guam">Guam</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MiA">Midway Atoll</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="NMI">Northern Mariana Islands</option>
                          <option value="Ohio">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="PR">Puerto Rico</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="USVI">US Virgin Islands</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WIS">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>
                        {!user.state && (
                          <span style={{ color: "red" }}>
                            {" "}
                            {errField.stateErr}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="selector_country">
                          Country<span>Required*</span>
                        </label>
                        <input
                          className="form-control"
                          disabled
                          id="country_selector"
                          name="country"
                          type="text"
                          value="United States of America"
                        />
                        {!user.country && (
                          <span style={{ color: "red" }}>
                            {errField.countryErr}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 form-group">
                        <label className="label" htmlFor="input_zipcode">
                          Zip Code<span>required*</span>
                        </label>
                        <input
                          className="form-control"
                          id="input_zipcode"
                          name="zipCode"
                          onChange={handleChange}
                          placeholder="E.g. 90001"
                          type="text"
                          value={user.zipCode}
                        />
                        {!user.zipCode && (
                          <span style={{ color: "red" }}>
                            {" "}
                            {errField.zipCodeErr}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="btn-wrapper mt-4">
                <button
                  className="btn btnclose"
                  onClick={prevStep}
                  type="button"
                >
                  Go Back
                </button>
                <ContinueButton disabled={!nextBtn} onClick={handleSubmit}>
                  Next Step
                </ContinueButton>
              </div>
              <div className="btn-wrapper mt-4 text-end"></div>
            </form>
          </div>
        </section>
      </Layout>
    </>
  )
}
Caregiverinfo.propTypes = {
  nextStep: PropTypes.func.isRequired,
  pationuser: PropTypes.object.isRequired,
  prevStep: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default Caregiverinfo
